/**
 * Component that shows detailed data about selected search result,
 * with a miniature of selected location's panorama.
 */
<template>
    <div id="SearchDetail">
        <div
            class="link-section cursor-pointer is-uppercase"
            @click="clearSelection">
            <span class="icon ">
                <img
                    src="../assets/chevron-left.svg"
                    height="10px" width="8px" />
                <p>{{ $t("message.backToSearch") }}</p>
            </span>
        </div>
        <div class="search-detail-content">
            <p>{{ resultDetails.title }}</p>
            <p>{{ resultDetails.detailAddress }}</p>
            <div class="search-detail-coordinates">
                <span class="icon ">
                    <img
                        src="../assets/icon-mapmarker.svg"
                        height="19px" width="13px" />
                    <p>{{ resultDetails.coordinates }}</p>
                </span>
            </div>
            <div class="details-image is-relative">
                <div
                    class="panorama-miniature-loader"
                    :class="{ 'is-hidden': !isLoadingMiniature }"></div>
                <div
                    class="panorama-miniature-error hero"
                    :class="{ 'is-hidden': isMiniatureErrorHidden }">
                    <div class="hero-body">
                        <div class="container">
                            <h1 class="title">&nbsp;</h1>
                            <h2 class="subtitle has-text-centered">
                                {{ $t('message.miniatureError') }}
                            </h2>
                        </div>
                    </div>
                </div>
                <div
                    :class="{ 'is-hidden': isLoadingMiniature }">
                    <template v-if="miniature">
                        <img
                            :src="miniature"
                            @click="goToPanorama">
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters('search', ['resultDetails']),
        ...mapState('search', [
            'miniature',
            'isLoadingMiniature',
            'hasMiniatureError',
        ]),

        isMiniatureErrorHidden() {
            const { isLoadingMiniature, hasMiniatureError } = this;
            return isLoadingMiniature || !hasMiniatureError;
        },
    },

    methods: {
        ...mapActions('search', ['clearSelection']),
        ...mapActions('panorama', ['selectCoordinates']),

        goToPanorama() {
            const { coordinates } = this.resultDetails;
            const [lat, lng] = coordinates.split(', ');
            this.selectCoordinates({ lat, lng });
        },
    },
};
</script>
